import React, { lazy, Suspense } from "react";

import { useStoreSelector } from "../../../store/store";

// import Loader from "../../UI/Loader/Loader";

// const DepositModal = lazy(() => import('../DepositModal/DepositModal'));
const DepositModal = lazy(() => import('../DepositModalNew/DepositModal'));
const InfoModal = lazy(() => import('../InfoModal/InfoModal'));
// const TransactionSettingsModal = lazy(() => import('../TransactionSettingsModal/TransactionSettingsModal'));
// const ConfirmModal = lazy(() => import('../ConfirmModal/ConfirmModal'));
const TransactionModal = lazy(() => import('../TransactionModal/TransactionModal'));
const WithdrawModal = lazy(() => import('../WithdrawModalNew/WithdrawModal'));
const WalletModal = lazy(() => import('../WalletModal/WalletModal'));
const PairSelectModal = lazy(() => import('../PairSelectModal/PairSelectModal'));
const MobileMenu = lazy(() => import('../MobileMenu/MobileMenu'));


const ModalsController: React.FC = () => {

	const { openedModals } = useStoreSelector(store => store.modals);


	return (
		<>
			{openedModals.map(modal => {
				switch (modal.modalName) {

					case 'deposit':
						return (
							<Suspense
								key={modal.modalName + modal.modalId}
								// fallback={<Loader/>}
								fallback={<></>}
							>
								<DepositModal
									modalName={modal.modalName}
									modalId={modal.modalId}
								/>
							</Suspense>
						)
					;

					case 'withdraw':
						return (
							<Suspense
								key={modal.modalName + modal.modalId}
								// fallback={<Loader/>}
								fallback={<></>}
							>
								<WithdrawModal
									modalName={modal.modalName}
									modalId={modal.modalId}
								/>
							</Suspense>
						)
					;

					case 'info':
						return (
							<Suspense
								key={modal.modalName + modal.modalId}
								// fallback={<Loader/>}
								fallback={<></>}
							>
								<InfoModal
									modalName={modal.modalName}
									modalId={modal.modalId}
									title={modal.title}
									message={modal.message}
									type={modal.type}
								/>
							</Suspense>
						)
					;

					/* case 'confirm':
						return (
							<Suspense
								key={modal.name + modal.modalId}
								fallback={<Loader/>}
							>
								<ConfirmModal
									name={modal.name}
									modalId={modal.modalId}
									promiseFork={modal.promiseFork}
									title={modal.title}
									message={modal.message}
									cancelButton={modal.cancelButton}
									confirmButton={modal.confirmButton}
								/>
							</Suspense>
						)
					; */

					case 'transaction':
						return (
							<Suspense
								key={modal.modalName + modal.modalId}
								// fallback={<Loader/>}
								fallback={<></>}
							>
								<TransactionModal
									modalName={modal.modalName}
									modalId={modal.modalId}
									transactionParams={modal.transactionParams}
								/>
							</Suspense>
						)
					;

					case 'wallet':
						return (
							<Suspense
								key={modal.modalName + modal.modalId}
								// fallback={<Loader/>}
								fallback={<></>}
							>
								<WalletModal
									modalName={modal.modalName}
									modalId={modal.modalId}
								/>
							</Suspense>
						)
					;

					case 'pairSelect':
						return (
							<Suspense
								key={modal.modalName + modal.modalId}
								// fallback={<Loader/>}
								fallback={<></>}
							>
								<PairSelectModal
									modalName={modal.modalName}
									modalId={modal.modalId}
								/>
							</Suspense>
						)
					;

					/* case 'mobileMenu':
						return (
							<Suspense
								key={modal.modalName + modal.modalId}
								// fallback={<Loader/>}
								fallback={<></>}
							>
								<MobileMenu
									modalName={modal.modalName}
									modalId={modal.modalId}
								/>
							</Suspense>
						)
					; */

					default:
						return null
					;
				}
			})}
		</>
	)
}

export default ModalsController;